import React, { Component } from "react";
import moment from "moment-timezone";
import Textarea from "react-textarea-autosize";

// Components
import SaveBtn from "../../utils/edit-item/SaveBtn";
import DeleteBtn from "../../utils/edit-item/DeleteBtn";

// Utils
import { handleKeyPress } from "../../../utils/forms/inputHandling";

// CSS
import "../../../css/forms/edit-item.css";

class TrainingEducationItemAdmin extends Component {
	render() {
		const { item, updateLoading } = this.props;

		return (
			<div
				className={
					"edit-item edit-item--rows" + (item.successfull ? ` successful-row` : ``)
				}
			>
				<div className="item-row">
					<input
						type="text"
						id="title"
						className="main-field"
						placeholder="Enter title"
						maxLength="255"
						disabled={updateLoading}
						value={item.title}
						onKeyPress={e => handleKeyPress(e, this.props.handleSubmit)}
						onChange={this.props.handleInputChange}
					/>
					<div className="item-date">
						{moment
							.utc(item.date_added)
							.local()
							.format("lll")}
					</div>
					<div className="btn-wrap">
						<SaveBtn
							shown={!!item.titleChanged}
							loading={!!item.saving}
							disabled={!!item.saving}
							onClick={this.props.handleSubmit}
						/>
						<DeleteBtn
							loading={!!item.saving}
							disabled={!!item.saving}
							onClick={this.props.deleteItem}
						/>
					</div>
				</div>
				<div className="item-row">
					<Textarea
						id="description"
						placeholder="Description"
						value={!!item.description ? item.description : ""}
						onChange={this.props.handleDescriptionChange}
					/>
				</div>
				<div className="item-row list-item--reviewer-list">
					<h4>Reviewers</h4>
					<div>
						{item.reviewers.length ? (
							item.reviewers.map(reviewer => {
								return (
									<a
										key={reviewer.id}
										className="reviewer-item"
										href={`mailto:${reviewer.email}`}
										target="_blank"
										rel="noopener noreferrer"
									>
										<div className="reviewer-item--name">
											{reviewer.fname} {reviewer.lname}
										</div>
										<div className="reviewer-item--email">{reviewer.email}</div>
									</a>
								);
							})
						) : (
							<div className="no-reviewers-msg">
								There are no reviewers signed up yet.
							</div>
						)}
					</div>
				</div>
			</div>
		);
	}
}

export default TrainingEducationItemAdmin;



// WEBPACK FOOTER //
// ./src/components/admin/training-education/TrainingEducationItemAdmin.js